import { __assign } from "tslib";
import { getLegacyBaseDriverFromWrapper } from '../../common/base-driver';
import { WarningMessageBox } from './message-box';
import { renderAndMountComponent } from '@wix/answers-lib';
import * as React from 'react';
var createMessageBoxDriver = function (wrapper, type) {
    var classNames = ".message-box." + type;
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, classNames, 'MessageBox');
    return {
        getText: function () { return baseDriver.getText(); }
    };
};
export var createWarningMessageBoxDriver = function (wrapper) {
    return createMessageBoxDriver(wrapper, 'warning');
};
export var createAttentionMessageBoxDriver = function (wrapper) {
    return createMessageBoxDriver(wrapper, 'attention');
};
export var createNeutralMessageBoxDriver = function (wrapper) {
    return createMessageBoxDriver(wrapper, 'neutral');
};
export var createWarningMessageBox = function (props, content) {
    var elem = renderAndMountComponent(React.createElement(WarningMessageBox, __assign({}, props), content));
    return createWarningMessageBoxDriver(elem);
};
//# sourceMappingURL=message-box.driver.js.map